import { Field, Label } from "./../components/UI/fieldset.jsx";
import { Input } from "../components/UI/input";
import { Textarea } from "../components/UI/textarea";
import { Button } from "../components/UI/button";
import { Pencil, Save } from "lucide-react";
import scheduler from "../assets/scheduler.png";

export default function RoleDesign() {
  const createdRoles = ["Office Helper", "Math Tutor", "Home Visitation"];

  return (
    <div className="flex h-full">
      {/* Left Column - Main Content (Now Smaller) */}
      <main className="flex-1 py-4 px-6 pt-0 mr-[20vw] overflow-auto gap-4">
        {/* Step 1 - Name of Role */}
        <section className="mt-4">
          <h2 className="text-lg font-semibold">Step 1: Role Name</h2>
          <Field className="mt-2">
            <Input placeholder="Enter role name" className="w-1/2" />
          </Field>
        </section>

        {/* Step 2 - Describe Work Involved */}
        <section className="mt-4">
          <h2 className="text-lg font-semibold">
            Step 2: Describe Work Involved
          </h2>
          <Field className="mt-2">
            <Textarea
              placeholder="Define what role does and how doing this role helps the program/mission"
              className="w-full h-20"
            />
          </Field>
        </section>

        {/* Step 3 - Eligibility Requirements */}
        <section className="mt-4">
          <h2 className="text-lg font-semibold">
            Step 3: Eligibility Requirements
          </h2>
          <div className="grid grid-cols-3 gap-4 mt-2">
            <Field>
              <Label>Age</Label>
              <Input placeholder="Enter age" className="w-full" />
            </Field>
            <Field>
              <Label>Training</Label>
              <Input placeholder="Enter training" className="w-full" />
            </Field>
            <Field>
              <Label>Additional Criteria</Label>
              <Input placeholder="Enter criteria" className="w-full" />
            </Field>
          </div>
        </section>

        {/* Step 4 - Key Info for Doing Role */}
        <section className="mt-4">
          <h2 className="text-lg font-semibold">
            Step 4: Key Info for Performing Role
          </h2>
          <div className="grid grid-cols-2 gap-4 mt-2">
            <Field>
              <Label>Address</Label>
              <Input placeholder="Enter address" className="w-full" />
            </Field>
            <Field>
              <Label>Name of Supervisor</Label>
              <Input placeholder="Enter supervisor's name" className="w-full" />
            </Field>
            <Field>
              <Label>Contact Number</Label>
              <Input placeholder="Enter contact number" className="w-full" />
            </Field>
            <Field>
              <Label>Dress Requirements</Label>
              <Input
                placeholder="Enter dress requirements"
                className="w-full"
              />
            </Field>
            <Field className="col-span-2">
              <Label>Instructions</Label>
              <Textarea
                placeholder="List any additional instructions"
                className="w-full h-20"
              />
            </Field>
          </div>
        </section>

        {/* Step 5 - Schedule & Needs */}
        <section className="mt-4">
          <h2 className="text-lg font-semibold">Step 5: Schedule & Needs</h2>
          <div className="grid grid-cols-2 gap-6 mt-2">
            {/* Left Column - Scheduler Placeholder */}
            <img src={scheduler} alt="scheduler" className="cursor-pointer" />
            {/* Right Column - # Needed per Shift */}
            <div className="flex flex-col justify-center">
              <Field className="flex items-center gap-4">
                <Label># Needed per Shift</Label>
                <Input type="number" className="w-16" min="1" />
              </Field>
              <div className="flex gap-2 mt-4">
                <Button variant="outline" size="sm">
                  Min
                </Button>
                <Button variant="outline" size="sm">
                  Max
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Right Column - Fixed Sections */}
      <aside className="w-[20vw] p-4 flex flex-col fixed right-0 top-[3rem] h-[calc(100vh-3rem)]">
        {/* AI-Generated Editor - Fixed at Top */}
        <div className="p-2 flex flex-col h-96">
          <h2 className="text-lg font-semibold">AI-Generated Editor</h2>
          <div className="flex-1 mt-2 bg-gray-200 flex items-center justify-center rounded-lg" />
          <div className="flex justify-end gap-1 mt-4">
            <Button variant="outline" size="sm">
              <Pencil className="w-4 h-4" />
            </Button>
            <Button size="sm">
              <Save className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {/* Created Roles - Fixed at Bottom */}
        <div className="bg-sky p-2 border-2 border-marigold flex flex-col items-start mt-auto">
          <h2 className="text-md font-semibold">Created Roles</h2>
          <ul className="mt-2 space-y-1 text-sm">
            {createdRoles.map((role, index) => (
              <li
                key={index}
                className="text-blue-600 underline cursor-pointer"
              >
                {role}
              </li>
            ))}
          </ul>
          <Button outline className="mt-2 self-end">
            See all
          </Button>
        </div>
      </aside>
    </div>
  );
}
